import { VariantType, useSnackbar } from 'notistack';

/**
 * Custom hook that provides a simplified snackbar function
 * with default options (autoHideDuration: 3000, center bottom position)
 *
 * @returns A showSnackbar function that takes a message and variant
 *
 * @example
 * const { showSnackbar } = useSnackbarHelper();
 * showSnackbar('Operation successful!', 'success');
 */
export default function useSnackbarHelper() {
  const { enqueueSnackbar } = useSnackbar();

  /**
   * Simplifies the snackbar function with default options
   *
   * @param {string} message the snackbar message to show
   * @param {VariantType} snackbarVariant the color of the snackbar to show (default: 'info')
   */
  const showSnackbar = (message: string, snackbarVariant: VariantType = 'info') => {
    enqueueSnackbar(message, {
      autoHideDuration: 3000,
      variant: snackbarVariant,
      anchorOrigin: { horizontal: 'center', vertical: 'bottom' },
    });
  };

  return { showSnackbar };
}
